import {CommonModule} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'oph-checkbox',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './oph-checkbox.component.html',
  styleUrl: './oph-checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphCheckboxComponent implements OnChanges {
  @Input() width: number = 20;
  @Input() color: 'brown' | 'green' | 'blue' = 'brown';
  @Input() control: FormControl;
  @Input() checked: boolean;
  @Input() text: string;
  @Input() textStyle: Object;
  @Input() textOrientation: 'left' | 'right' = 'left';
  @Input() minWidth: number = 0;
  @Input() gap: number = 12;

  @Output() valueChange = new EventEmitter<boolean>();

  // Signal to track if animations should be enabled (skip initial render)
  animationsEnabled = signal(false);

  // Track if this is the first change (initial binding)
  private isFirstChange = true;

  ngOnChanges(changes: SimpleChanges) {
    // Enable animations after the first change to the checked input
    if (changes['checked'] && !this.isFirstChange) {
      this.animationsEnabled.set(true);
    }
    this.isFirstChange = false;
  }

  onCheckbox() {
    // Enable animations on click
    this.animationsEnabled.set(true);

    if (this.control) {
      this.control.setValue(!this.control.value);
    }
    this.valueChange.emit(!this.checked);
  }
}
